<template>
    <div>
        <HomeLayout :isShowDelivery="false" customClass="lg:max-w-5xl">
            <div class="">
                <div class="font-bold text-18 text-a-brown-502314 text-center py-4">
                    {{lbl.myOrder.title}}
                </div>
                <template v-if="isLoginAccount">
                    <div
                        class="grid grid-cols-2 border-b border-a-brown-d7c7b8 text-14 font-bold text-center text-a-brown-502314">
                        <div class="py-2" @click="clickTab('ongoing')"
                            :class="{'border-b-4 border-a-red-d62300 text-a-red-d62300': tabActive == 'ongoing'}"
                            >{{lbl.myOrder.ongoing}}</div>
                        <div class="py-2 " @click="clickTab('orderhistory')"
                            :class="{'border-b-4 border-a-red-d62300 text-a-red-d62300': tabActive == 'orderhistory'}"
                            >{{lbl.myOrder.order_history}}</div>
                    </div>
                    <div v-show="tabActive=='ongoing'" class="py-4">
                        <OnGoing @onLoaded="onLoadSuccess('orderTracking')"></OnGoing>
                    </div>
                    <div v-show="tabActive=='orderhistory'">
                        <OrderHistory ref="order-history" @onLoaded="onLoadSuccess('orderHistory')"></OrderHistory>
                    </div>
                </template>
                <template v-else>
                    <SearchOrder />
                </template>

            </div>
        </HomeLayout>
    </div>
</template>

<script>
//component
import HomeLayout from "@/components/Layout/Page/HomeLayout.vue";
import OrderHistory from "../component/OrderHistory/OrderHistory.vue";
import SearchOrder from "../component/SearchOrder/SearchOrder.vue";
import OnGoing from "../component/OrderDeliveryDetail/OnGoing.vue";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import DeliveryMixin from "@/mixin/DeliveryMixin.js";
export default {
    name: "MyOrder",
    mixins: [ModalMixin, AuthStatusMixin,LocaleMixin,DeliveryMixin],
    components: {
        HomeLayout,
        OrderHistory,
        SearchOrder,
        OnGoing
    },
    data: function () {
        return {
            tabActive: "ongoing",
            loadingStatus: {
                orderHistory: false,
                orderTracking: false
            },
        };
    },
    mounted: function () {
        if (this.isLoginAccount) {
            this.modal.loadingModal.show();
            this.setScrollLoadMore();
        }
    },
    beforeUnmount: function () {
        window.onscroll = null;
    },
    created: function () {
        this.tracking.screenName('shopping_bag');

        if (this.$route.query.from == "shoppingcart" ) {
            this.getDelivery();
        }
    },
    methods: {
        setScrollLoadMore: function () {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        loadMore: function () {
            this.$refs['order-history'].loadMore();
        },
        clickTab: function (tabActive) {
            this.tabActive = tabActive;
        },
        onLoadSuccess: function (api) {
            if (!this.loadingStatus[api]) {
                this.loadingStatus[api] = true;
                let found = false;
                for (let i in this.loadingStatus) {
                    if (!this.loadingStatus[i]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    this.modal.loadingModal.hide();
                }
            }
        },
    }
}
</script>

<style>
</style>
